module.exports = __webpack_public_path__ + "static/media/solidity-beginner.a88c2eb4.png";